<!-- src/components/NewsDetail.vue -->
<template>
    <div class="news-detail-container">
        <div class="news-detail">
            <h2>{{ news.title }}</h2>
            <div>{{ news.date }}</div>
            <div v-html="news.content"></div>
            <div v-if="news.id <= 13">
                <img v-for="n in news.imageCount" :key="n" :src="getImagePath(news.id, n)" :alt="`News Image ${n}`"
                    style="width: 100%; margin-top: 20px;">
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            news: {}
        };
    },
    created () {
        const newsId = this.$route.params.id;
        const allNews = [
            { id: 13, date: '2024-06-27', imageCount: 1, title: '韩国艾乐肤化妆品株式会社最新公告', content: '<p>我司韩国艾乐肤化妆品株式会社（ΛKF COSMETIC CO.,LTD.）系“ΛKF”品牌所有人和“ΛKF”系列商标在中国大陆境内的商标注册人，享有“ΛKF”系列商标的注册商标专用权，近期针对市场上出现的混淆视听的各种信息，现我司发表以下公告如下：</p>' },

            { id: 12, date: '2024-06-20', imageCount: 1, title: '声明函', content: '<p>声明函</p>' },

            { id: 4, date: '2024-06-04', imageCount: 9, title: '授权书', content: '<p>2024年4月30号，韩国艾乐肤化妆品株式会社给艾乐肤（广州）生物科技有限公司的授权书，已经经过公证，具体文件，公证授权书具体内容如下</p>' },

            { id: 1, date: '2024-05-22', imageCount: 1, title: '韩国艾乐肤化妆品株式会社声明函', content: '<p>2024年5月11日，韩国艾乐肤化妆品株式会社给各渠道客户发了一份声明函，声明函具体内容如下</p>' },
            { id: 2, date: '2024-05-22', imageCount: 1, title: '终止授权通知函（韩国艾乐肤化妆品株式会社发给浙江艾乐肤生物科技有限公司）', content: '<p>2024年5月10日，韩国艾乐肤化妆品株式会社对浙江艾乐肤生物科技有限公司发出了终止授权通知函，通知函内容如下图</p>' },
            { id: 3, date: '2024-05-22', imageCount: 1, title: '终止授权通知函（韩国艾乐肤化妆品株式会社发给青岛艾乐肤化妆品有限公司）', content: '<p>2024年5月10日，韩国艾乐肤化妆品株式会社对青岛艾乐肤化妆品有限公司发出了终止授权通知函，具体通知函内容如下</p>' },

            { id: 6, date: '2024-05-22', imageCount: 24, title: '一份2022年授权的声明书', content: '<p>关于2022年6月17日的一份授权书的声明，声明书内容如下图</p>' },
            { id: 5, date: '2024-05-22', imageCount: 13, title: '韩国艾乐肤化妆品株式会社发出了中国区的新授权书', content: '<p>2024年4月30日，韩国艾乐肤化妆品株式会社将ΛKF的多枚商标授权给艾乐肤（广州）生物科技有限公司在中国境内使用，授权书具体内容如下图</p>' },
            // { id: 6, date: '2024-05-22', imageCount: 2, title: '商标使用许可终止通知书（韩国艾乐肤化妆品株式会社发给青岛艾乐肤化妆品有限公司）', content: '<p>2024年4月29日，韩国艾乐肤化妆品株式会社对青岛艾乐肤化妆品有限公司发出了商标使用许可终止通知书，通知书具体内容如下图</p>' },


            //12345
            { id: 11, date: '2024-05-22', imageCount: 3, title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东瑶华网络科技有限公司）', content: '<p>2024年4月24日，韩国艾乐肤化妆品株式会社对山东瑶华网络科技有限公司发出了合同解除通知函，通知函具体内容如下图</p>' },
            { id: 10, date: '2024-05-22', imageCount: 2, title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东八月初网络科技有限公司第一分公司）', content: '<p>2024年4月24日，韩国艾乐肤化妆品株式会社对山东八月初网络科技有限公司第一分公司发出了合同解除通知函，通知函具体内容如下图</p>' },
            { id: 9, date: '2024-05-22', imageCount: 2, title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给山东八月初网络科技有限公司）', content: '<p>2024年4月24日，韩国艾乐肤化妆品株式会社对山东八月初网络科技有限公司发出了合同解除通知函，通知函具体内容如下图</p>' },
            { id: 8, date: '2024-05-22', imageCount: 2, title: '合同解除通知函（邹鲁波发给中国人民共和国人刘进华）', content: '<p>2024年4月24日，邹鲁波对中国人民共和国人刘进华发出了合同解除通知函，通知函具体内容如下图</p>' },
            { id: 7, date: '2024-05-22', imageCount: 3, title: '合同解除通知函（韩国艾乐肤化妆品株式会社发给中国人民共和国人刘进华）', content: '<p>2024年4月24日，韩国艾乐肤化妆品株式会社对中国人民共和国人刘进华发出了合同解除通知函，通知函具体内容如下图</p>' },




        ];


        this.news = allNews.find(news => news.id === parseInt(newsId));
    },
    methods: {
        getImagePath (newsId, imageIndex) {
            return require(`../assets/images/newsList/${newsId}/${imageIndex}.jpg`);
        }
    }
};
</script>

<style>
/* 桌面端 */
@media only screen and (min-width: 996px) {
    .news-detail {
    width: 60%;
}
.news-detail-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 10rem;
    /* 确保距离导航栏有一定距离 */
    padding: 20px;
}
}
/* 移动端 */
@media only screen and (max-width: 996px) {
    .news-detail {
    width: 100%;
}
.news-detail-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 5rem;
    /* 确保距离导航栏有一定距离 */
    padding: 20px;
}
}



</style>
